export { default, Props } from './Img';
